import { render, staticRenderFns } from "./OrderChecklistDetailsDialogList.vue?vue&type=template&id=88410f12&"
import script from "./OrderChecklistDetailsDialogList.vue?vue&type=script&lang=ts&"
export * from "./OrderChecklistDetailsDialogList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports